import { render } from "./NoCommission.vue?vue&type=template&id=6bc98300"
import script from "./NoCommission.vue?vue&type=script&lang=js"
export * from "./NoCommission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__